export default {
    nl: {
        search: {
            title: 'Vind je favoriete zaak',
            intro: 'Ontvang de cadeaubon van je favoriete restaurant, winkel of activiteit direct per e-mail óf gedrukt op de deurmat.',
            placeholder: 'Zoek op stad of zaak',
            button: 'Zoeken',
            result: 'resultaat',
            results: 'resultaten',
            found: 'gevonden',
            noResults: 'Geen resultaten',
            noResultsDescription: 'Probeer andere zoektermen te gebruiken.'
        },
        company: {
            redeemableAt: 'De cadeaukaart is in te leveren bij:',
            noAddresses: 'Dit bedrijf heeft nog geen inleveradres(sen).',
            aboutTitle: '{company} cadeaubon',
            aboutDescription: 'Ontvang je {company} cadeaubon direct per e-mail of binnen 2 werkdagen gedrukt op de deurmat!',
            aboutButton: '{company} cadeaubon',
            alsoLike: 'Dit vind je misschien ook leuk',
            allGiftcards: 'Bekijk alle cadeaubonnen',
            returnAddress: 'inleverpunten',
            viewReturnAddresses: 'Inleverpunten bekijken',
            view: 'Bekijken',
            freeShipping: 'Altijd gratis postverzending',
            freeShippingFrom: 'Gratis postverzending vanaf € {price}',
            recommended: 'Cadeautip',
            tipTitle: 'cadeautips',
            tipSubTitle: 'Geef bijvoorbeeld eens een arrangement cadeau!',
            orderGiftCard: 'Bestel als cadeaubon',
            buyNow: 'Koop cadeaubon',
        },
        general: {
            expiresAt: 'Vervaldatum'
        },
        cookieConsent: {
            request: {
                title: 'We gebruiken cookies',
                description: 'Om onze website optimaal te laten werken, gebruiken we cookies. We delen ook informatie over je gebruik van onze site met onze partners.',
                accept: 'Accepteren',
                deny: 'Weigeren',
                settings: 'Instellingen',
            },
            required: {
                title: 'Extra toestemming vereist',
                description: 'Voor de gekozen actie is extra toestemming vereist. Ga akkoord met het inschakelen van onderstaande cookies om door te gaan.',
            },
            preferences: {
                title: 'Cookievoorkeuren aanpassen',
                description: ' In dit scherm kun je jouw voorkeuren instellen voor het gebruik van cookies tijdens je bezoek aan onze website. Door je cookievoorkeuren aan te passen, kun je bepalen welke informatie we verzamelen.',
                save: 'Opslaan',
            },
            type: {
                title: {
                    functionality_storage: 'Functionele cookies (verplicht)',
                    security_storage: 'Veiligheidsgerelateerde cookies (verplicht)',
                    ad_storage: 'Opslag voor advertenties',
                    ad_user_data: 'Gebruikersgegevens voor advertenties',
                    ad_personalization: 'Gepersonaliseerde advertenties',
                    analytics_storage: 'Analytische cookies',
                    personalization_storage: 'Personalisatie cookies',
                },
                description: {
                    functionality_storage: 'Deze cookies ondersteunen essentiële functies van onze website of app, zoals taalinstellingen, en zorgen ervoor dat je voorkeuren onthouden worden.',
                    security_storage: 'Essentieel voor het waarborgen van de veiligheid op onze website. Deze cookies helpen bij authenticatieprocessen, fraudepreventie en beveiliging van jouw gegevens en betalingen.',
                    ad_storage: 'Deze cookies worden gebruikt om informatie op te slaan die relevant is voor advertentieactiviteiten op onze website. Ze helpen ons bij het tonen van relevante advertenties en meten de effectiviteit van onze advertentiecampagnes.',
                    ad_user_data: 'Met deze cookies geef je toestemming voor het delen van je gegevens met derde partijen voor online advertentiedoeleinden. Dit helpt ons bij het aanbieden van advertenties die aansluiten op jouw interesses.',
                    ad_personalization: 'Deze instelling stelt ons in staat om advertenties te personaliseren op basis van jouw voorkeuren en interacties op onze website, voor een meer relevante en gerichte advertentie-ervaring.',
                    analytics_storage: 'Cookies gerelateerd aan analytische gegevens, zoals de duur van je bezoek aan onze website. Deze informatie wordt gebruikt om de gebruikerservaring te verbeteren en inzicht te krijgen in hoe onze website wordt gebruikt.',
                    personalization_storage: 'Met deze cookies kunnen we content personaliseren, zoals het tonen van je (bedrijfs)naam, op basis van je eerdere interacties en voorkeuren voor een meer gepersonaliseerde ervaring op onze site.',
                },
            },
        },
    },
    en: {
        search: {
            title: 'Discover your favorite place',
            intro: 'Receive the gift card for your favourite restaurant, shop, or activity either by email or delivered right to your doorstep.',
            placeholder: 'Search by city or establishment',
            button: 'Search',
            result: 'result',
            results: 'results',
            found: 'found',
            noResults: 'No results',
            noResultsDescription: 'Try using different search terms.'
        },
        company: {
            redeemableAt: 'You can redeem this gift card at:',
            noAddresses: 'This company has no return address(es) yet.',
            aboutTitle: '{company} gift card',
            aboutDescription: 'Order your {company} gift card now and receive it directly by email or printed by post.',
            aboutButton: '{company} gift card',
            alsoLike: 'You may also like this',
            allGiftcards: 'Shop all gift cards',
            returnAddress: 'redemption points',
            viewReturnAddresses: 'View redemption points',
            view: 'View',
            freeShipping: 'Always free postal delivery',
            freeShippingFrom: 'Free postal delivery from € {price}',
            recommended: 'Recommended',
            tipTitle: 'recommendations',
            tipSubTitle: 'Consider gifting someone an arrangement, for instance!',
            orderGiftCard: 'Order Gift Card',
            buyNow: 'Order Gift Card',
        },
        general: {
            expiresAt: 'Expiration date'
        },
        cookieConsent: {
            request: {
                title: 'We use cookies',
                description: 'To ensure our website works optimally, we use cookies. We also share information about your use of our site with our partners.',
                accept: 'Accept',
                deny: 'Deny',
                settings: 'Settings',
            },
            preferences: {
                title: 'Adjust cookie preferences',
                description: 'In this screen, you can adjust your preferences for the use of cookies during your visit to our website. By adjusting your cookie preferences, you can determine which information we collect.',
                save: 'Save',
            },
            type: {
                title: {
                    functionality_storage: 'Functional cookies (required)',
                    security_storage: 'Security-related cookies (required)',
                    ad_storage: 'Ad storage',
                    ad_user_data: 'User data for ads',
                    ad_personalization: 'Personalized ads',
                    analytics_storage: 'Analytical cookies',
                    personalization_storage: 'Personalization cookies',
                },
                description: {
                    functionality_storage: 'These cookies support essential functions of our website or app, such as language settings, and ensure your preferences are remembered.',
                    security_storage: 'Essential for ensuring security on our website. These cookies help with authentication processes, fraud prevention, and securing your data and payments.',
                    ad_storage: 'These cookies are used to store information relevant to advertising activities on our website. They help us show relevant ads and measure the effectiveness of our ad campaigns.',
                    ad_user_data: 'With these cookies, you consent to sharing your data with third parties for online advertising purposes. This helps us offer ads that match your interests.',
                    ad_personalization: 'This setting allows us to personalize ads based on your preferences and interactions on our website, for a more relevant and targeted ad experience.',
                    analytics_storage: 'Cookies related to analytical data, such as the duration of your visit to our website. This information is used to improve the user experience and gain insights into how our website is used.',
                    personalization_storage: 'With these cookies, we can personalize content, such as showing your (company)name, based on your previous interactions and preferences, for a more personalized experience on our site.',
                },
            },
        },
    }
}
